module.exports = __webpack_public_path__ + "img/ywbk20_en.f02ec652.jpg";